import { render, staticRenderFns } from "./prepaid-recharge.vue?vue&type=template&id=18757910&scoped=true&"
import script from "./prepaid-recharge.vue?vue&type=script&lang=js&"
export * from "./prepaid-recharge.vue?vue&type=script&lang=js&"
import style0 from "./prepaid-recharge.vue?vue&type=style&index=0&id=18757910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18757910",
  null
  
)

export default component.exports